
export const ConsentSource = {
    UNKNOWN: 0,
    USER: 1,						// Nastavil uzivatel v CRM (ten, ktery je v enteredBy)
    FRONT_UI: 2,					// Nastavil subjekt udaju ve front.do UI
    API: 3,						// XML connector nebo REST API
    LEGACY: 4						// Konverze z historickych dat (napr. pri upgradu)
};

export interface Consent {
    id?: number;
    party?: number;
    name: string;
    type: number;
    source: number;
    value: boolean;
    description?: string;
    entered: string | null;
    enteredBy: number | null;
}

export interface ConsentType {
    id: number;
    name: string;
}

export interface ConsentTypeSorted extends ConsentType {
    level: number;
}

/*
		JsonObjectBuilder b = Json.createObjectBuilder();
		if (! embedded) {
			b.add("id", this.id);
			b.add("party", this.party);
		}
		try {
			String name = ListManager.get().getList(CONSENT_TYPE_LIST).getItemName(String.valueOf(this.getConsentType()));
			b.add("name", name);
		}
		catch (Exception ex) {
			logger.log(Level.WARNING, "Error", ex);
			b.add("name", "Error - "+ex.getMessage());
		}
		b.add("type", this.getConsentType());
		b.add("source", this.getSourceType());
		b.add("value", this.isValue());
		if (StrUtil.notEmpty(this.description)) b.add("description", this.description);
		Jsonable.add(b, "entered", this.entered);
		Jsonable.addId(b, "enteredBy", this.enteredBy);

 */
